module.exports = __webpack_public_path__ + "static/media/test11_4.489328e0.png";